/**
 * Excel-specific constants: row indices, formatting, date handling, and limits.
 */

/** Market Watch sheet layout (0-based row indices) */
export const MW_LAYOUT = {
  /** Header row index (0-based) — Row 6 in Excel */
  HEADER_ROW: 5,
  /** Data start row index (0-based) — Row 7 in Excel, always HEADER_ROW + 1 */
  DATA_START_ROW: 6,
  /** Minimum rows for header presence check */
  MIN_ROWS_FOR_HEADER: 6,
} as const;

/** Generic Excel data layout used in apiService.ts */
export const EXCEL_LAYOUT = {
  /** Default header row index (0-based) for data extraction */
  HEADER_ROW_INDEX: 3,
  /** Number of sample rows for formula detection */
  SAMPLE_ROWS: 10,
} as const;

/** Row data chunking */
export const EXCEL_DATA = {
  /** Rows written per batch to Excel (performance optimization) */
  CHUNK_SIZE: 500,
  /** Max rows sent to fuzzy match API (prevents 413 errors) */
  MAX_FUZZY_MATCH_ROWS: 2000,
  /** Default data fetch limit for sales/advertising data */
  DEFAULT_DATA_LIMIT: 50000,
} as const;

/** Excel date serial number handling */
export const EXCEL_DATE = {
  /** Excel epoch: December 30, 1899 */
  EPOCH_YEAR: 1899,
  EPOCH_MONTH: 11,
  EPOCH_DAY: 30,
  /** Minimum serial number to attempt date conversion */
  SERIAL_MIN: 10000,
  /** Modern date lower bound (~1982) */
  SERIAL_MODERN_MIN: 30000,
  /** Upper bound for valid date serials */
  SERIAL_MAX: 100000,
  /** Epoch adjustment for 1900 leap year bug */
  EPOCH_ADJUSTMENT_DAYS: 2,
  /** Hours/minutes/seconds/ms conversion factors */
  MS_PER_DAY: 24 * 60 * 60 * 1000,
} as const;

/** Column letter calculation */
export const EXCEL_COLUMN = {
  /** Base for column letter conversion (A-Z = 26) */
  ALPHABET_BASE: 26,
  /** ASCII offset for column letter (64 = 'A' - 1) */
  ASCII_OFFSET: 64,
} as const;

/** JESS renderer layout */
export const JESS_LAYOUT = {
  /** Total columns used for merged-cell layout */
  TOTAL_COLS: 12,
  /** KPI metrics displayed per row */
  METRICS_PER_ROW: 3,
  /** Columns per individual metric card */
  COLS_PER_METRIC: 4,
} as const;
